import { Navigate, RouteObject } from 'react-router';
import { RouteConfig } from '~/routes/routeConfig';
import { DocumentDirection } from '~/types/document';
import lazyImport from '~/utils/lazyImport';
const RecurrenceList = lazyImport(() => import('~/views/recurrences/RecurrenceList'));

export const recurrencesRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={'./received'} replace />,
  },
  {
    path: 'issued',
    element: <RecurrenceList direction={DocumentDirection.issued} />,
  },
  {
    path: 'received',
    element: <RecurrenceList direction={DocumentDirection.received} />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Outstanding.buildLink()} replace />,
  },
];
